import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, NoData } from '@node-space/ui-components'
import { useWalletContext } from 'hooks/context'

export const NoTransactions = () => {
  const { t } = useTranslation()
  const wallet = useWalletContext()
  return (
    <Box padding={16}>
      <NoData
        dataName="transactions"
        description={t('wallets.emptyStateDescription', { walletName: wallet?.description })}
      />
    </Box>
  )
}
